import React from 'react';

import  SocialStudiesCCA3to52024  from 'views/SocialStudiesCCA3to52024';
const BlogNewsroomPage = () => {
return <SocialStudiesCCA3to52024/>
};
export default BlogNewsroomPage;